document.addEventListener('DOMContentLoaded', () => {
  // Cart quantity auto-submit (existing behavior, unchanged).
  document.querySelectorAll('[data-quantity]').forEach(el => {
    el.addEventListener('change', () => el.form?.submit());
  });

  initMobileNav();
  initStickyHeader();
  initScrollReveal();
});

function initMobileNav() {
  const toggle = document.querySelector('.nav-toggle');
  const nav = document.querySelector('.nav');
  const closeBtn = document.querySelector('.nav-close');
  const overlay = document.querySelector('[data-nav-overlay]');
  if (!toggle || !nav) return;

  const open = () => {
    nav.classList.add('is-open');
    overlay?.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };
  const close = () => {
    nav.classList.remove('is-open');
    overlay?.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  toggle.addEventListener('click', () => {
    nav.classList.contains('is-open') ? close() : open();
  });
  closeBtn?.addEventListener('click', close);
  overlay?.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && nav.classList.contains('is-open')) close();
  });
  // Close the panel automatically after a link is chosen.
  nav.querySelectorAll('a').forEach(link => link.addEventListener('click', close));
}

function initStickyHeader() {
  const header = document.querySelector('.header');
  if (!header) return;
  const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
}

function initScrollReveal() {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion || !('IntersectionObserver' in window)) return;

  const targets = document.querySelectorAll(
    '.section > .page-width > h2, .card, .collection-tile, .quote, .faq details, .hero__content, .newsletter'
  );
  if (!targets.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  targets.forEach((el, index) => {
    el.classList.add('reveal', 'reveal-stagger');
    el.style.setProperty('--reveal-delay', `${Math.min(index % 4, 3) * 90}ms`);
    observer.observe(el);
  });
}
